/**
 * Sync-status vocabulary for a replicable record's lifecycle towards the
 * backend.
 *
 * String-valued by design so the value can be stored verbatim in
 * `metadata.syncInfo.syncStatus`, replicated unchanged to the Desktop store,
 * and filtered server-side without translation.
 *
 * - `UnSynced` — the initial state: local source of truth, never yet accepted
 *                by the backend. Re-applied only when a push failed without
 *                reaching the backend at all (connection drop, timeout).
 * - `Syncing`  — claimed by an in-flight backend push (guards against
 *                concurrent double-sends).
 * - `Synced`   — accepted by the backend; terminal success state.
 * - `Failed`   — the backend answered and refused the record (validation error,
 *                conflict, server error — the successor of the legacy
 *                `ConflictOrError`). Still local and still retried on every
 *                cycle: it is a visible marker carrying `syncStatusMessage`,
 *                not a terminal state, so a rejected record is never stranded.
 *
 * The `UnSynced` / `Failed` split is applied by `classifySyncFailure()` and
 * holds for every replicable entity — sales orders, cash transactions and cash
 * register status logs alike.
 */
export enum ReplicationSyncStatus {
  UnSynced = 'UnSynced',
  Syncing = 'Syncing',
  Synced = 'Synced',
  Failed = 'Failed'
}
